import { Common, color, Widget } from '@stockbit/ui';
import styled, { css, keyframes } from 'styled-components';

const { Flex, Text, Input, Autocomplete } = Common;

const { Select, Table: WidgetTable, Modal: ModalWidget } = Widget;

const cellType = {
  up: color.primary,
  down: color.sunsetOrange,
  neutral: color.suvaGrey,
  default: color.highempahis,
};

const HeaderContainer = styled(Flex).attrs({
  align: 'center',
  justify: 'space-between',
})`
  position: relative;
  background: ${color.aliceBlue};
  height: 40px;
  cursor: pointer;
  border-bottom: 1px solid ${color.gainsboro};
  padding-left: 10px;
`;

const Td = styled(Text).attrs((props) => ({
  height: '30px',
  padding: '0 10px',
  size: '12.5px',
  type: props.type || 'default',
}))`
  cursor: pointer;

  ${({ type }) =>
    css`
      color: ${cellType[type]};
    `}
`;

const Th = styled(Td).attrs({
  weight: 'bold',
  size: '11px',
})``;

const ListContainer = styled(Flex).attrs({ align: 'center' })`
  border-bottom: 1px solid ${color.aliceBlue};
  cursor: pointer;

  :hover {
    background: ${color.aliceBlue};
  }
`;

const SelectGroup = styled(Select)`
  width: 80%;
  .ant-select-selector {
    border-bottom: none !important;
  }
`;

const InputGroup = styled(Input)`
  border-bottom: none;
  border-left: none;
`;

const Tag = styled(Text).attrs({
  color: color.light,
  weight: 'bold',
  px: '3px',
})`
  background: ${color.dimgray};
  border-radius: 2px;
`;

const containerAnimation = keyframes`
    0% {
      padding-left : 30%;
    }
    100% {
      padding-left : 20px;
    }
`;

const List = styled(Text).attrs({ height: '30px' })`
  animation: 0.5s ${containerAnimation} linear forwards;
  cursor: pointer;
  :hover {
    background: ${color.aliceBlue};
  }
`;

const AutoCompleteStock = styled(Autocomplete)`
  .stock-search-dropdown {
    top: 30px !important;
  }
`;

const Table = styled(WidgetTable)`
  font-family: var(--regular-font);
`;

const Modal = styled(ModalWidget)`
  .ant-modal-header {
    border-bottom-color: transparent;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    height: auto;
    padding: 10px 24px 0 !important;
  }

  .ant-modal-close-x {
    margin: 10px;

    svg {
      width: 14px;
      height: 14px;
    }
  }

  .ant-modal-content {
    border-radius: 3px !important;
  }

  .ant-modal-body {
    padding: 16px;
  }
`;

const InputModal = styled(Input).attrs({
  height: '32px',
  width: '100%',
})`
  &::placeholder {
    font-family: var(--bold-font);
  }
`;

export {
  HeaderContainer,
  Td,
  Th,
  ListContainer,
  SelectGroup,
  InputGroup,
  Tag,
  List,
  AutoCompleteStock,
  Table,
  Modal,
  InputModal,
};
